app.service('productCardConfig', function(pageConfig) {
	const PAGE_NAME = 'productCard';

	function getData() {
		return pageConfig.getData(PAGE_NAME);
	}

	function setData(data) {
		pageConfig.setData({ page: PAGE_NAME, data });
	}

	return {
		getData,
		setData
	};
});
